// artifacts/papacito/src/lib/iosGateCooldown.ts
//
// Cooldown for the iOS "Add to Home Screen" install gate (IOSInstallGateModal).
// The behavioral push system substitutes this gate for the push prompt on iOS
// Safari (web push needs the PWA installed first). Without a cooldown the gate
// re-appears on every behavioral variant trigger (first swipe, the 16s timer,
// etc.), which nags the user. This module is kept import-free so the pure
// decision is unit-testable in isolation.

/** How long to suppress the iOS install gate after it was last shown. */
export const IOS_GATE_COOLDOWN_MS = 10 * 60 * 1000;

/**
 * True when the iOS install gate was shown recently enough that it should not
 * be shown again yet. `lastShownAtMs` is the epoch-ms timestamp of the last
 * show (null / 0 means never shown).
 */
export function isIosGateOnCooldown(lastShownAtMs: number | null, nowMs: number): boolean {
  if (lastShownAtMs == null || lastShownAtMs <= 0) return false;
  return nowMs - lastShownAtMs < IOS_GATE_COOLDOWN_MS;
}
